import * as React from "react";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import GradeRoundedIcon from "@mui/icons-material/GradeRounded";
import { useSelector, useDispatch } from "react-redux";
import { antwoordOp, zetAntwoord } from "../lib/enquete";

const labels = {
  0.5: `${0.5*2}/10`,
  1: `${1*2}/10`,
  1.5:  `${1.5*2}/10`,
  2:  `${2*2}/10`,
  2.5:  `${2.5*2}/10`,
  3: `${3*2}/10`,
  3.5: `${3.5*2}/10`,
  4:  `${4*2}/10`,
  4.5:  `${4.5*2}/10`,
  5:  `${5*2}/10`,
};

function getLabelText(value) {
  return `${value} Star${value !== 1 ? "s" : ""}, ${labels[value]}`;
}

// De sterren van een enquêtevraag. Het antwoord hoort bij de vraag via idenquetefield (lib/enquete.js, 14-10-2026).
export default function RatingComponent({ data, name, setField, Css }) {
  const dispatch = useDispatch();
  const { addFields } = useSelector((store) => store?.feedback);
  const [hover, setHover] = React.useState(-1);
  const value = antwoordOp(addFields, data?.idenquetefield)?.rating ?? 0;

  const handleChange = (newValue) => {
    dispatch(setField(zetAntwoord(addFields, data?.idenquetefield, { rating: newValue ?? 0, label: labels[newValue] })));
  };

  return (
    <Box sx={{ width: "100%", mx: "auto" }}>
      <Rating
        name={name}
        value={value}
        precision={0.5}
        getLabelText={getLabelText}
        onChange={(event, newValue) => handleChange(newValue)}
        onChangeActive={(event, newHover) => setHover(newHover)}
        icon={<GradeRoundedIcon style={{ width: 42, height: 42}} fontSize="inherit" />}
        emptyIcon={<StarOutlineRoundedIcon style={{ opacity: 0.7, width: 42, height: 42,color: Css?.StarClr }} fontSize="inherit" />}
        sx={{
          mt: 3,
          gap: 0.5, // Reduced gap for closer stars
        }}
      />
      {value !== null && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
          <Typography sx={{ color: Css?.AnswerPlachoderClr, fontSize: "14px" ,fontWeight:'bold'}}>
            {labels[hover !== -1 ? hover : value]}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
